module.exports = __webpack_public_path__ + "media/notification.65cc6ded.mp3";